import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postLogin } from '../../../api';
import { setJWTToken } from '@sonar-software/sonar-ts-lib';

export const securityAuthenticationLoginPostAsyncSlice = createPostAsyncSlice({
	httpSagaOptions: {
		allowUnauthorized: true,
		successDataHandlers: [
			(data) => {
				if (data.token) {
					setJWTToken(data.token);
				}
			}
		]
	},
	name: 'SecurityAuthorizationLogin',
	receive: false,
	request: true,
	requestHandler: postLogin
});
